/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Supplement processing cost estimate
 * @export
 * @interface EstimateSupplementCost200Response
 */
export interface EstimateSupplementCost200Response {
    /**
     * Number of credits required for supplement processing
     * @type {number}
     * @memberof EstimateSupplementCost200Response
     */
    creditsNeeded: number;
    /**
     * Total cost in cents
     * @type {number}
     * @memberof EstimateSupplementCost200Response
     */
    costCents: number;
    /**
     * Billing tier code
     * @type {string}
     * @memberof EstimateSupplementCost200Response
     */
    tierCode: string;
    /**
     * Cost per credit in cents
     * @type {number}
     * @memberof EstimateSupplementCost200Response
     */
    creditRateCents: number;
}

/**
 * Check if a given object implements the EstimateSupplementCost200Response interface.
 */
export function instanceOfEstimateSupplementCost200Response(value: object): value is EstimateSupplementCost200Response {
    if (!('creditsNeeded' in value) || value['creditsNeeded'] === undefined) return false;
    if (!('costCents' in value) || value['costCents'] === undefined) return false;
    if (!('tierCode' in value) || value['tierCode'] === undefined) return false;
    if (!('creditRateCents' in value) || value['creditRateCents'] === undefined) return false;
    return true;
}

export function EstimateSupplementCost200ResponseFromJSON(json: any): EstimateSupplementCost200Response {
    return EstimateSupplementCost200ResponseFromJSONTyped(json, false);
}

export function EstimateSupplementCost200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateSupplementCost200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'creditsNeeded': json['creditsNeeded'],
        'costCents': json['costCents'],
        'tierCode': json['tierCode'],
        'creditRateCents': json['creditRateCents'],
    };
}

export function EstimateSupplementCost200ResponseToJSON(json: any): EstimateSupplementCost200Response {
    return EstimateSupplementCost200ResponseToJSONTyped(json, false);
}

export function EstimateSupplementCost200ResponseToJSONTyped(value?: EstimateSupplementCost200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creditsNeeded': value['creditsNeeded'],
        'costCents': value['costCents'],
        'tierCode': value['tierCode'],
        'creditRateCents': value['creditRateCents'],
    };
}

